import { render, staticRenderFns } from "./GestioneAttivitaTasksListPage.vue?vue&type=template&id=580cb124"
import script from "./GestioneAttivitaTasksListPage.vue?vue&type=script&lang=js"
export * from "./GestioneAttivitaTasksListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports